<template>
  <v-row justify="space-around">
    <v-col cols="10">
      <v-file-input
        v-model="fileInput"
        label="Marker image"
        prepend-icon="mdi-map-marker"
        accept="image/*"
        @click:clear="clearAttachImg"
        @change="attachImg"></v-file-input>
    </v-col>
    <v-col cols="2">
      <img :src="imageUrl?imageUrl:oldMarkerUrl"/>
    </v-col>
  </v-row>
</template>

<script>
import loadImage from 'blueimp-load-image';

export default {
  name: 'MarkerImageUploader',
  props: {
    oldMarkerUrl: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      imageUrl: null,
      fileInput: null,
    };
  },
  destroyed() {
    this.clearAttachImg();
  },
  computed: {
    imageData: {
      get: function () {
        console.log(this.value);
        return this.value;
      },
      set: function (newValue) {
        this.value = newValue;
        this.$emit("input", newValue);
      }
    }
  },
  methods: {
    setPreImage(url) {
      this.imageUrl = url;  
    },
    attachImg(file) {
      loadImage.parseMetaData(file, (data) => {
        const options = {
          maxHeight: 128,
          maxWidth: 128,
          canvas: true
        };
        if (data.exif) {
          options.orientation = data.exif.get('Orientation');
        }
        this.displayImage(file, options);
      });
    },
    displayImage(file, options) {
      loadImage(
        file,
        async (canvas) => {
          const data = canvas.toDataURL(file.type);
          const blob = this.base64ToBlob(data, file.type);
          const url = window.URL.createObjectURL(blob);
          this.imageData = data;
          this.imageUrl = url;
        },
        options
      );
    },
    clearAttachImg() {
      this.imageData = null;
      this.imageUrl = null;
      this.fileInput = null;
      // TODO: check this code is needed or not.
      // if (this.$refs.fileInput && this.$refs.fileInput.value !== undefined) {
      //   this.$refs.fileInput.value = '';
      //   window.URL.revokeObjectURL(this.imageUrl);
      // }
    },
    base64ToBlob(base64, fileType) {
      const bin = atob(base64.replace(/^.*,/, ''));
      const buffer = new Uint8Array(bin.length);
      for (let i = 0; i < bin.length; i++) {
        buffer[i] = bin.charCodeAt(i);
      }
      return new Blob([buffer.buffer], {
        type: fileType ? fileType : 'image/png'
      });
    }
  }
};
</script>

<style scoped>
</style>
